import React from 'react';
import { IconProps } from '../IconProps';
const SvgNovaVoice = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 16" fill="none" {...props}>
    <path
      d="M.818 9.636A.819.819 0 010 8.818V7.182a.818.818 0 011.636 0v1.636a.819.819 0 01-.818.818zM17.181 9.636a.818.818 0 01-.818-.818V7.182a.818.818 0 011.637 0v1.636a.819.819 0 01-.819.818zM4.092 14.545a.819.819 0 01-.819-.818V2.273a.818.818 0 011.637 0v11.454a.819.819 0 01-.818.818zM7.365 12.364a.818.818 0 01-.818-.818V4.455a.819.819 0 011.636 0v7.09a.818.818 0 01-.818.819zM10.635 15.636a.819.819 0 01-.819-.818V1.182a.819.819 0 011.637 0v13.636a.818.818 0 01-.818.818zM13.908 12.364a.818.818 0 01-.818-.818V4.455a.819.819 0 011.636 0v7.09a.818.818 0 01-.818.819z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgNovaVoice;
